import React, {useState} from "react";
import {XFilterElementParams} from "@michalrakus/x-react-web-lib/XLazyDataTable";
import {DataTableFilterMetaData} from "primereact/datatable";
import {KlientSluzba} from "../../model/klient/klient-sluzba.entity";
import {XFilterMatchMode} from "@michalrakus/x-react-web-lib/FindParam";
import {KlientSluzbaAutoComplete} from "./KlientSluzbaAutoComplete";

export const KlientSluzbaColumnFilter = (props: {filterParams: XFilterElementParams; dropdownButtonEnabled?: boolean;}) => {

    const [klientSluzbaError, setKlientSluzbaError] = useState<string | undefined>(undefined); // mozno by stacilo pouzit useRef

    // klientSluzba (uzivatelom vybrana hodnota) je vytiahnuty vyssie do lazy tabulky
    // dovod je ten ze ho modifikuje lazy tabulka napr. ak user stlaci clearFilter

    // precitame klientSluzba (uzivatelom vybranu hodnotu) z filtra lazy tabulky
    const getKlientSluzba = (): any => {
        let klientSluzbaFromFilter: KlientSluzba | null = null;
        const filterItem: DataTableFilterMetaData | undefined = props.filterParams.getFilterItem("klientSluzba.klient.menoPriezviskoPrezyvka") as DataTableFilterMetaData;
        // pri zmene match mode z inputu na tento autocomplete pada, preto to tu osetrujeme - trebalo by pri zmene match mode osetrit (vymazat value)
        if (filterItem && typeof filterItem.value === 'object') {
            klientSluzbaFromFilter = filterItem.value;
        }
        return klientSluzbaFromFilter;
    }

    // setneme klientSluzba (uzivatelom vybranu hodnotu) do filtra lazy tabulky
    const setKlientSluzba = (klientSluzba: any) => {
        let filterItem: DataTableFilterMetaData = {
            value: klientSluzba,
            matchMode: XFilterMatchMode.X_FILTER_ELEMENT, // <- toto by bolo fajn vyhodit, vracat len (value, customFilterItems)
            customFilterItems: klientSluzba !== null ? [{where: `[klientSluzba] = ${klientSluzba.id}`, params: {}}] : undefined
        } as unknown as DataTableFilterMetaData;
        // poznamka: na backende bude pouzity customFilterItems
        props.filterParams.setFilterItem("klientSluzba.klient.menoPriezviskoPrezyvka", filterItem, true); // prebijeme ne-autoFilter pre ine match mode-y
    }

    return <KlientSluzbaAutoComplete value={getKlientSluzba()} onChange={setKlientSluzba}
                                     error={klientSluzbaError} onErrorChange={(error: (string | undefined)) => setKlientSluzbaError(error)}
                                     dropdownButtonEnabled={props.dropdownButtonEnabled}/>;
}
